import React from 'react';
import style from './coffeemachine.module.css';

export default function CoffeeMachine() {
  return (<div className={style.container}>
    <div className={style.coffeeHeader}>
        <div className={[
            style.coffeeHeader__buttons, 
            style.coffeeHeader__buttonOne].join(" ")}></div>
        <div className={[
            style.coffeeHeader__buttons, 
            style.coffeeHeader__buttonTwo].join(" ")}></div>
        <div className={style.coffeeHeader__display}></div>
        <div className={style.coffeeHeader__details}></div>
    </div>
    <div className={style.coffeeMedium}>
        <div className={style.coffeeMedium__exit}></div>
        <div className={style.coffeeMedium__arm}></div>
        <div className={style.coffeeMedium__liquid}></div>
        <div className={[
            style.coffeeMedium__smoke, 
            style.coffeeMedium__smokeOne].join(" ")}></div>
        <div className={[
            style.coffeeMedium__smoke, 
            style.coffeeMedium__smokeTwo].join(" ")}></div>
        <div className={[
            style.coffeeMedium__smoke, 
            style.coffeeMedium__smokeThree].join(" ")}></div>
        <div className={[
            style.coffeeMedium__smoke, 
            style.coffeeMedium__smokeFour].join(" ")}></div>
        <div className={style.coffeeMedium__cup}></div>
    </div>
    <div className={style.coffeeFooter}></div>
    </div>);
}
